<template>
    <div class="ve-list-page ve-list-page--embedded">
        <div style=" display:flex; width:100%; background:#fff;line-height:30px;height:38px;border-bottom:2px solid #389;padding-top:3px">
            <div style="width:70px;line-height:30px" >
                <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                <el-link :disabled="addBool" @click="addRec" :underline="false" ><span style="font-size:12px;font-weight:600 ">{{ $LANG('0138', '新增') }} </span></el-link>
            </div>
            <span style="color:black;margin-left:10px;margin-right:5px;font-size:12px">{{ $LANG('0681', '字段查询') }}</span>
    
            <el-select v-model="selparam"  :placeholder="$LANG('1675', '请选择列名')" filterable  size="small" style="width:120px; ">
                <span v-for="item in tabCol" :key='item.key' >
                    <el-option :label="$translate.getColTitle(item, $store.state.lang)" :value="item.key" v-if="item.thide=='N'"></el-option>
                </span>
            </el-select>
            <el-input clearable ref="refinput" :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="queryEvent('N')" size="small" style="width:320px; height:30px; ">
                <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                    <span v-for="item in operArr" :key='item.IDSEQ'>
                        <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                    </span>
                </el-select>
                <el-button size="small" slot="append" icon="el-icon-search" @click="queryEvent('N')" ></el-button>
            </el-input>
            <el-button type="primary" icon="iconfont icon-daochu" @click="expExcel" size="mini" style="margin-left:15px;height:30px;margin-top:1px">{{ $LANG('0172', '导出数据') }}</el-button>
            <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
            <el-link @click="dropSel('fldset')" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>
        </div>
        <div class="ve-list-page__body">
            <div class="ve-list-page__table">
                <ve-table :columns="vueCol"
                    :table-data="tabData"
                    :columnHiddenOption="columnHiddenOption"
                    :border-around="true"
                    :border-x="true"
                    :border-y="true"
                    :fixed-header="true"
                    row-key-field-name="IDSEQ"
                    :row-style-option="rowStyleOption"
                    :cell-style-option="cellStyleOption"
                    :max-height="tabHeight"
                    :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
                    :virtual-scroll-option="virtualScrollOption"
                    :scroll-width="0"
                    :column-width-resize-option="columnWidthResizeOption"
                    :cellSelectionOption="{enable: false}"
                    v-loading="v_loading"
                    :element-loading-text="$LANG('1959', '加载中')"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 251, 255, 0.8)"
                    id="sku_asset2_load"
                    ref="tableRef">
                </ve-table>
            </div>
            <div class="ve-list-page__pagination">
                <div style="float: left;font-size:12px">
                    <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
                </div>
            </div>
        </div>
        <!-- 编辑表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag :show-close="false" :visible.sync="addWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style=" overflow-y:auto;height:70vh;">
                <div class="one-div" style="margin-top:0px"><span class="oneRow"> 基本信息</span> </div>
                <Form :model="formRow" :label-width="120"  label-position="right" inline  :rules="ruleValidate">  
                    <span v-for="(item,index) in tabCol.filter(item=>item.fhide=='N')" :key="index" >
                        <FormItem  :label="item.title"  :class=" 'item-width'" :prop="item.key"  >                  
                            <el-date-picker size="medium" :disabled="saveFlag" type="date"  v-if="item.edcss==='date'" v-model="formRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                            <el-checkbox size="medium" border v-else-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="formRow[item.key]" style="width:100%"></el-checkbox> 
                            <el-select size="medium" :disabled="saveFlag" v-else-if="item.edcss==='select'"  v-model="formRow[item.key]" clearable   style="width:100%">
                                <el-option v-for="(it,ind) in comboArr[item.key]" :key="ind" :label="it.CNAME" :value="it.CNAME"></el-option>
                            </el-select>
                            
                            <el-input-number size="medium" :precision="item.dotnum" v-else-if="item.edcss=='number'"  style="width:100%" :disabled="saveFlag||item.disabled=='Y'" v-model="formRow[item.key]" controls-position="right"></el-input-number>
                            <el-input size="medium" :placeholder="item.holder" type="text" v-else :disabled="item.disabled==='Y'?true:false||saveFlag "  v-model="formRow[item.key]"></el-input>
                        </FormItem>
                    </span>
                </Form>
                <div class="one-div" style="margin-top:2px"><span class="oneRow"> 附件明细</span> </div>
                <div style="display:flex" >
                    <Upload
                        ref="upload"
                        name="upfile"
                        :data="uploadData"
                        :show-upload-list="false"
                        :before-upload="beforeImgFile"
                        :on-success="successImgFile"
                        :on-progress="handleProgress"
                        :with-credentials="true"                            
                         
                        :max-size="10240"
                        
                        :on-exceeded-size="handleMaxSize"
                        type="drag"
                        :disabled="saveFlag"
                        :action="uploadUrl"
                        style="display: inline-block;width:200px; ">                           
                        <div style="padding: 1px 0;width:200px;height:150px;">
                            <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                            <p style="color:#515a6e;margin-top:5px;">将文件拖动此处或点击上传</p>
                        </div>                                                       
                    </Upload> 
                    <div style="display:flex;margin-left:30px;"  >
                        <span v-for="(item,index) in imgData" :key="index">  
                            <div v-if="item.FILEPATH&&item.FILEPATH.toLowerCase().lastIndexOf('.pdf')>-1" style="width:200px;height:180px;border:1px solid #e8eaec;overflow-y:hidden">
                                <iframe :src="item.FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                            </div>
                            <el-image :preview-src-list="[item.FILEPATH]"  fit="scale-down" v-else   style="width:200px;height:180px;margin-right:30px;" :src="item.FILEPATH"/> 
                            <div style="width:200px;height:25px;border:1px solid #e8eaec;overflow-y:hidden">
                                <span style="font-weight:600;font-size:12px;color:red"> 文件名：</span>{{item.FILENM}}
                            </div>
                            <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                                <el-link :disabled="saveFlag" :underline="false" @click="imgDel(item ,index)"><Icon type="md-close" /> 删除</el-link>
                                <el-link v-if="item.FILEPATH.toLowerCase().lastIndexOf('.pdf')>-1" :underline="false" style="margin-right:10px;" @click="pdfShow(item.FILEPATH)"><Icon type="ios-search" />查看</el-link>
                            </div>
                        </span>
                    </div> 
                </div>
                
            </div>
            <div style="height:35px;line-height:30px;border-top:2px solid #ccc;padding-top:2px; ">
            <span style="float:right">
                <el-button type="info" @click="addWin=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                <el-button :disabled="saveFlag"   @click="saveRec" size="small" type="primary" style="margin-left:50px;" icon="iconfont icon-baocun"  > 保存  </el-button> 
            </span>
        </div> 
        </el-dialog>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :show-close="false" :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-image  src="/assets/authorize/loading.gif" ></el-image>  
        </el-dialog>
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">正在上传中...</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
        </el-dialog>
        <!-- 字段设置 -->
        <el-dialog class="pub_dialog" v-dialogDrag v-if="setWin" :visible.sync="setWin" width="480px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">字段显示设置</span>
            </div>
            <easy-win v-bind:colArr ="fldArr" @child-exit="setWin=false" @child-sure="setOk"></easy-win>
        </el-dialog>
    </div>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate,getDate2} from '../../api/Select' 
import easyWin from '../datamgt/easy_field.vue'
 
 
export default {
    name:'sku_asset2',
    data () {
        return {
            videoUploadPercent:0,
            Accept: "png,jpg,jpeg,gif,pdf", //上传文件格式限制
            videoFlag:false,
            loadWin:false,
            promptWin:false,
            prompt:'',
            imgData:[],
            uploadData:{}, //上传数据
            uploadUrl: '/xuper_oss/ftpUpload_nocheck' ,
            ruleValidate:{},
            formRow:{},
            txtparam:'',
            selparam:'IDNO',
            oper:'like',
            operArr:[],
            tabCol:[],
            vueCol:[],
            setWin:false,
            fldArr:[],
            columnHiddenOption: {
                defaultHiddenColumnKeys: [],
            },
            columnWidthResizeOption: {
                enable: true, // default false
                minWidth: 20, // column resize min width
                // column size change
                sizeChange: ({ column, differWidth, columnWidth }) => {
                    const targetCol =this.vueCol.find(item=>item.key==column.key)
                    if (targetCol){
                        targetCol.width =columnWidth
                    }
                },
            },
            rowStyleOption: { clickHighlight: true },
            cellStyleOption: {
                headerCellClass: () => 'table-head-cell-class',
                bodyCellClass: () => 'table-body-cell-class1',
            },
            virtualScrollOption: { enable: false },
            cfmBool:false, //审核 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
            appBool:false, //作废权限
            delBool:false,
            cancelBool:false,
            v_loading:false,
            current:1,
            saveFlag:false,
            tabData:[],  
            dtlData:[],
            actitem:'one',
            addWin:false,
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            v_row:{},
            v_inputrow:{},
            v_sort:'asc',
            input_hold:this.$LANG('1718', '请输入查询的值'),
            notNull:[],
            delImg:[],
            stfgBool:true,
            comboArr:[],
            v_index:0,
            allData:[],
            rowSize:100,
            dataCount:0,
        }
    },
    components: {
        easyWin,
    },
    computed: {
        subHeight: function() {
            return (window.innerHeight - 185) + 'px';
        }, 
        tabHeight: function() {
            return 'calc(100vh - 185px)';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        },
    },
    mounted () {
        //操作符
        getBaseData('xuper_auth/getTableRecMany','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        //用户表单新增、编辑、审核、作废权限 :frmid:  ID
        getBaseData(this.v_url,'idseq',this.$cookies.get('v_idseq') ,'frmidseq','227473','v_sys_user_priv',' and issel=\'Y\'').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        }) 
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','227473','LSTSEQ','2','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        })
        this.comSelect()
    },
    created () {
        if (this.v_username){
            // INITIALIZE
            this.getTabField()
            this.qryTabData()
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {
        dropSel(val){
            if (val =='fldset'){  //字段设置显示--隐藏
                this.fldArr =[]
                getTabColOrData(this.v_url ,'V_USER_FLDSET','idseq','227473-2','userno',this.v_username,'','',' order by sortby').then((res) => {
                    let v_setArr =res.result
                    //预处理：将 v_setArr中所有的FLDNO提取出来，转为大写，存入 Set
                    const existFldnos =new Set()
                    v_setArr.forEach(item=>existFldnos.add(item.FLDNO.toUpperCase()))
                    // 遍历 vueCol, 检查是否存在
                    this.vueCol.forEach(item =>{
                        const keyUpper = (item.key||'').toUpperCase()
                        if (!existFldnos.has(keyUpper)){
                            let v_obj ={'IDSEQ':'227473-2',LSTSEQ:'',COLWIDTH:item.width,CORPID:this.v_corpid,USERNO:this.v_username,FLDNO:item.key,FLDNM:item.title, 'VISFLAG':'Y'}
                            v_setArr.push(v_obj)
                            // 同时也添加到 Set 中，防止 vueCol 中有重复的 key 导致重复添加
                            existFldnos.add(keyUpper)
                        }
                    })
                    //构建Map,源数组 : key ---> COLWIDTH
                    const widthMap =new Map(this.vueCol.map(item=>[item.key,item.width]))
                    //遍历目标数组并更新
                    let updateColumns =v_setArr.map(col =>{
                        if (widthMap.has(col.FLDNO)){
                            return {...col ,COLWIDTH:widthMap.get(col.FLDNO)}
                        }
                        return col
                    })
                    this.fldArr =[...updateColumns]
                })
                this.setWin =true
            }
        },
        getSetList(){
            getTabColOrData(this.v_url, 'V_USER_FLDSET','idseq','227473-2','userno',this.v_username,'','',' order by sortby').then((res) => {
                let v_data =res.result
                if (v_data && v_data.length>0) { // 有用户个性化记录
                    let v_arr=[]
                    this.columnHiddenOption['defaultHiddenColumnKeys'] =[]
                    // 1、隐藏 ，2、列宽 3、排序
                    v_data.forEach(item=>{
                        if (item['VISFLAG'] =='N') {
                            this.columnHiddenOption['defaultHiddenColumnKeys'].push(item['FLDNO'])
                        }else{
                            v_arr.push(item['FLDNO'])
                        }
                    })
                    this.$refs["tableRef"].showColumnsByKeys(v_arr)
                    this.$refs["tableRef"].hideColumnsByKeys(this.columnHiddenOption['defaultHiddenColumnKeys'])
                    //1.1 构建 Map : key -> {width,sortby,isfix} ,使用 Map 提高查找效率
                    const configMap =new Map() //建立索引映射
                    v_data.forEach(item =>{
                        configMap.set(item['FLDNO'],{COLWIDTH:item.COLWIDTH,SORTBY:item.SORTBY,ISFIX:item['ISFIX']})
                    })
                    //console.log(JSON.stringify(configMap))
                    //1.2 遍历 vueCol ,同步 width 宽度 与 冻结 fixed
                    this.vueCol.forEach(col =>{
                        const  targetCol= configMap.get(col['key'])
                        if (targetCol){
                            col.width =targetCol['COLWIDTH']
                            col.fixed =targetCol['ISFIX']=='Y'?"left":targetCol['ISFIX']=='R'?"right":false
                        }
                    })
                    //1.3 根据个性化的 SORTBY排序 来更新
                    this.vueCol.sort((a,b)=>{
                        const targetA =configMap.get(a['key'])
                        const targetB =configMap.get(b['key'])
                        const sortA = (targetA  && targetA.SORTBY!==undefined)?targetA.SORTBY:9999
                        const sortB = (targetB  && targetB.SORTBY!==undefined)?targetB.SORTBY:9999
                        return sortA - sortB
                    })
                }
            })
        },
        setOk(v_obj){
            v_obj.forEach((item,index)=>item['SORTBY']=index+1)
            this.loadWin =true
            this.$axios({
                method: 'post',
                url: 'xuper_auth/batDtlSave2' ,
                data: {p_json:JSON.stringify(v_obj), p_table:'USER_FLDSET',p_idseq:'227473-2', p_action:'S' },
            }).then(res=>{
                if (res.code=='200') {
                    this.getSetList()
                    this.setWin =false
                    this.loadWin =false
                }else{
                    this.promptWin =true
                    this.prompt =res.result
                    this.loadWin =false
                }
            })
        },
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.tabData = this.allData          
            }else{
                this.tabData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
            }
        },
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.tabData = this.allData.slice(_start,_end);
        },
        //查询图片数据
        qryImgData(idseq){
            this.imgData=[]
            getTabColOrData(this.v_url,'V_mat_img','idseq',idseq,'filety','IMG').then((res) => {                
                if (res){
                    this.imgData =res.result
                }
            })
        },
        refreshTableLayout(){
            this.$nextTick(() => {
                const table = this.$refs.tableRef
                if (table && typeof table.doLayout === 'function') table.doLayout()
            })
        },
        //导出
        expExcel(){
            this.loadWin =true   
            //导出
            this.$axios({
                method: 'post',
                url:'xuper_auth/report/GenExcel',
                data: {p_idseq:'227473',p_lstseq:'2',p_json:JSON.stringify(this.allData),p_action:'模具明细'},
                responseType:'blob' //关键，声明响应类型为二进制流
            }).then(response=>{ 
                // 从响应头解析后端设置的文件名
                // 创建Blob对象并触发下载  创建下载链接
                const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob)
                link.download = '模具明细_'+getDate('full')+'.xls'
                link.click()
                URL.revokeObjectURL(link.href)
                this.loadWin =false
            }) 
        },
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: this.v_url+'',
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'227473',p_cond:' and lstseq in (1,2)' ,p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData(this.v_url,'parentno',res.result[k].COMBO ,'corpno',this.v_corpid,'V_BASE_DATA','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        //图片删除，操作数组
        imgDel(item,index){
            if(item['IDSEQ'] && item['LSTSEQ']){
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/getBaseData',
                    data: {p_key:'refidseq',p_value:item['IDSEQ'],p_key2:'reflstseq',p_value2:item['LSTSEQ'],p_table:'V_MAT_IMG'},
                }).then(res=>{  
                    if(res.result.length>0 && res.result){
                        this.promptWin =true
                        this.prompt ='此附件已存在引用，不能删除'
                    }else{
                        this.$confirm('你确定要删除此图片吗','提示',{
                            confirmButtonText: '确定',
                            cancelButtonText:'取消',
                            customClass:'messageBox',
                            showClose:false,
                            closeOnClickModal:false,
                            closeOnPressEscape:false,
                            type:'info',
                        }).then(()=>{
                            this.delImg.push({IDSEQ:item['IDSEQ'],LSTSEQ:item['LSTSEQ'],FILEPATH:item['FILEPATH'],PATH:item['PATH']}) 
                            this.imgData.splice(index, 1);    
                        }).catch(()=>{})
                    }
                })
            }else{
                this.$confirm('你确定要删除此图片吗','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    this.delImg.push({IDSEQ:item['IDSEQ'],LSTSEQ:item['LSTSEQ'],FILEPATH:item['FILEPATH'],PATH:item['PATH']}) 
                    this.imgData.splice(index, 1);    
                }).catch(()=>{})
            }
        },
        pdfShow(pdfurl){
            let routeUrl = this.$router.resolve({
                path: '/fullPreview',
                query: {fileUrl:pdfurl},
            });
            window.open(routeUrl.href, '_blank');
        },
        //上传显示进度
        handleProgress(event,file,fileList){
            this.videoFlag = true
            this.videoUploadPercent = Math.floor(event.percent)
        },
         //文件格式验证错误时的钩子
        handleFormatError (file) {
            // pop() 它会移除数组的最后一个元素，并返回这个被移除的元素
            const extension =file.name.split('.').pop().toLowerCase()
            //禁止上传的类型
            const forbiddenType=['exe','dmg']
            if (forbiddenType.includes(extension)){
                this.promptWin =true
                this.prompt ='exe 与 dmg 不能上传'
                //return false //阻止上传
            }else{
                this.promptWin =true
                this.prompt='文件格式错误,'+file.name + ' 是不正确, 请选择图片格式或PDF'
            }
        },
        //文件超出指定文件大小限制的钩子
        handleMaxSize (file) {
            this.promptWin =true
            this.prompt=file.name + ' 文件太大, 不能超出10M' 
        },
        // 文件上传成功时的钩子
        successImgFile(res,file){
            this.videoUploadPercent=0 
            this.videoFlag = false
            let v_filename='/assets/basedict/'+this.fileName+file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
  
            if (res.code=='200'){
                this.imgData.push({FILEPATH:this.$store.state.nasUrl+res.result,FILENM:file.name,FILETY:'IMG',PATH:'/web/web_images/material/'+res.result,HASHVAL:res.hashvalue})                   
            }else if (res.code=='201'){ // 文件哈希值存在的情况下
                this.imgData.push({FILEPATH: res.filepath,FILENM:file.name,FILETY:'IMG',PATH:'',REFIDSEQ:res.idseq,REFLSTSEQ:res.lstseq})                   
            }else{
                this.promptWin =true
                this.prompt =res.result
            }            
        },
        //上传文件之前的钩子 :on-format-error="handleFormatError"
        beforeImgFile (file) {
            //console.log(JSON.stringify(file))
            const extension =file.name.split('.').pop().toLowerCase()
            //禁止上传的类型
            const forbiddenType=['exe','dmg']
            if (forbiddenType.includes(extension)){
                this.promptWin =true
                this.prompt ='exe 与 dmg 不能上传'
                return false //阻止上传
            }else{
                this.fileName= getDate('year')+'-AS'     
                this.uploadData = {
                    code: this.fileName ,
                    p_table:'mat_img',
                    p_idseq:this.formRow['IDSEQ'],
                    p_type:'IMG',
                    p_path:'/web/web_images/material/',
                    p_user:this.v_username
                }
                let promise = new Promise(resolve => {
                this.$nextTick(function() {
                        resolve(true)
                    })
                });
                return promise
            }
        },
        saveRec(){
            var vm =this 
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.formRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=item.FLDNM+'不能为空'
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool) {    
                let obj_ ={} ,vm=this 
                Object.assign(obj_,vm.formRow,{ 'CORPID':this.v_corpid  }) 
                this.$axios({  //传入 p_frmid 参数是为了生成 表单 的编码
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(obj_), p_table:'BS_DEV',frmid:'1'},
                }).then(res=>{ 
                    if(res.code ==='200')  { 
                        let idseq_=res.idseq 
                        //3、图片保存
                        for(let k=0;k<this.imgData.length;k++){
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/tableBodySave',
                                data: {p_json:JSON.stringify(Object.assign(this.imgData[k] )), p_table:'mat_img',p_idseq:idseq_},
                            }).then(res=>{
                                
                            })
                        } 
                        //图片删除处理
                        for(let k=0;k<this.delImg.length;k++){
                            let v_filepath=this.delImg[k]['FILEPATH'],v_path=this.delImg[k]['PATH']
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/delTabRec',
                                data: {p_key:'idseq',p_value:this.delImg[k]['IDSEQ'],p_key2:'lstseq',p_value2:this.delImg[k]['LSTSEQ'],p_key5:'filepath',p_value5:this.delImg[k]['FILEPATH'],p_table:'mat_img'},
                            }).then(res=>{      
                                if(res.code !=='200')  {  
                                    this.prompt=res.message
                                    this.promptWin=true
                                }else{                          
                                    //删除群晖上的文件 ,如果 是重复文件上传时 v_path 是空的，这时是不要删除真正的文件
                                    if (v_filepath.indexOf('https://')>-1 && v_filepath && v_path){
                                        this.$axios({
                                            method: 'post',
                                            url: '/xuper_oss/ftpDelete',
                                            data: {p_path:'/volume1'+v_path},
                                        }).then(res=>{ 
                                            console.log(res.result)
                                        })
                                    }
                                }        
                            })        
                        }
                        
                        this.delImg=[]
                        this.addWin =false
                        setTimeout(() => {
                            this.qryTabData()
                        }, 500);
                    }
                })
            }
        },
        delRec(row,index){
            this.$confirm('你确定要删除此行记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                //发起删除请求
                var vm=this
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'BS_dev'},
                }).then(res=>{      
                    if(res.code =='200')  {           
                        this.tabData.splice(index,1)  
                    }else{
                        this.promptWin=true
                        this.prompt=res.result
                    }        
                }) 
     
            }).catch(()=>{})
        },
        editRec(row,val,index){
            this.saveFlag =val=='Y'?true:false
            this.formRow =JSON.parse(JSON.stringify(row))
            this.v_index =index
            this.addWin =true
            this.qryImgData(row['IDSEQ'])
        },
        rowShow(){
            this.v_row = {}
            this.v_inputrow = {}
            this.txtparam = ''
            this.oper = 'like'
            this.current = 1
            this.queryEvent('N')
        } ,
        getRowKey(row){
            return row.IDSEQ
        },
        addRec(){
            this.formRow={STFG:'N', IDSEQ:''}
            this.addWin =true
        },
 
        //查询
        qryTabData(){
            this.current = 1
            this.queryEvent('N')
        },
        inputChg(e,column){
            this.v_inputrow[column]=e.target.value
            this.v_row[column] =e.target.value
        },
        inputQry(){
            this.current =1
            this.queryEvent('N')
        },
        sortChange(params){
            let v_key=params.key ,v_edcss=''
            if (this.v_sort =='asc'){
                this.v_sort ='desc'
            }else if (this.v_sort =='desc'){
                this.v_sort ='asc'
            }
            this.vueCol.some(item=>{
                if (item['key']==v_key){
                    v_edcss =item['edcss']
                }
            })
            this.tabData.sort((a, b) => {
                if (v_edcss =='number' ){
                    if (this.v_sort =='asc'){
                        return a[v_key] == null ? -1 : b[v_key] == null ? 1 : a[v_key] -b[v_key]
                    }else if (this.v_sort =='desc'){
                        return b[v_key] == null ? -1 : a[v_key] == null ? 1 : b[v_key] -a[v_key]
                    }else{
                        return 0
                    }
                }else{
                    let nameA = a[v_key]?a[v_key].toUpperCase():a[v_key]
                    let nameB = b[v_key]?b[v_key].toUpperCase():b[v_key]
                    if (this.v_sort =='asc'){
                        return nameA == null ? -1 : nameB== null ? 1 : nameA > nameB ? -1 : 1
                    }else{
                        return nameA == null ? 1 : nameB== null ? -1 : nameA > nameB ? 1 : -1
                    }
                }
            })
        },
        queryEvent(v_where){
            let v_cond ='' , v_oper='' ,v_edcss=''
            if (this.selparam){ //列1
                this.vueCol.some(item=>{
                    if (item['key']==this.selparam){
                        v_edcss =item['edcss']
                    }
                })
                if (this.oper==='like'){
                    v_cond=v_cond+' and  '+this.selparam+'  like  \'%' + this.txtparam+'%\' '
                } else{
                    if (this.txtparam){
                        if (v_edcss=='number'){
                            v_cond=v_cond+' and  '+this.selparam  +this.oper+ this.txtparam
                        }else {
                            v_cond=v_cond+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                        }
                    }
                }
            }
            Object.keys(this.v_row).filter(item=>item.indexOf('#OPER')<0).forEach(item=>{
                if (this.v_row[item] ){
                    this.vueCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (this.v_row[`#OPER`+item]){
                        v_oper =this.v_row[`#OPER`+item]
                    }
                    if (!v_oper){
                        v_oper ='like'
                    }
                    if (v_oper =='like'){
                        v_cond =v_cond +' and upper('+item+')  like  upper(\'%'+ (this.v_row[item]).trim()+'%\')'
                    }else{
                        if (v_edcss =='number' ){
                            v_cond =v_cond +' and '+item+ v_oper + this.v_row[item]
                        }else if ( v_edcss=='date'){
                            v_cond =v_cond +' and substr('+item+',1,10)'+ v_oper +'\''+this.v_row[item] +'\''
                        }else{
                            v_cond =v_cond +' and  '+item +v_oper+'\''+ (this.v_row[item]).trim()+'\''
                        }
                    }
                }
            })
            if (v_where =='N'){
                this.getTabList(v_cond)
            }
        },
        //订单明细
        getTabList(cond){
            this.v_loading =true
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond+' order by '+this.selparam+' desc',p_table:'V_BS_DEV'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.allData =res.result
                    this.initPage()
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        const table = this.$refs.tableRef
                        if (table && typeof table.setHighlightRow === 'function' && this.tabData[this.v_index]) {
                            table.setHighlightRow({ rowKey: this.tabData[this.v_index].IDSEQ })
                        }
                    })
                }else{
                    this.promptWin=true
                    this.prompt=res.code+':'+res.result
                }
                this.v_loading=false
            })
        },
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','227473','lstseq','2','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    let item =res.result[k]
                        vm.tabCol.push({
                            title: item.title,
                            key: item.key,
                            align: item.align,
                            width: item.width,
                            thide: item.THIDE,
                            fhide: item.FHIDE,
                            edcss: item.EDCSS,
                            disabled: item.DISABLED,
                            dotnum: item.DOTNUM,
                            holder: item.HOLDER,
                            sortable: item.SORTABLE,
                        })
                        if (item['THIDE']=='N'){
                            vm.vueCol.push({
                                field: item.key,
                                key: item.key,
                                title: item.title,
                                type: item.EDCSS === 'checkbox' ? 'check' : item.EDCSS,
                                edcss: item.EDCSS,
                                align: item.align,
                                width: Number(item.width),
                                thide: item.THIDE,
                                fhide: item.FHIDE,
                                sortable: false,
                                disabled: item.DISABLED,
                                ellipsis: { showTitle: true },
                                renderHeaderCell: ({column}, h) => {
                                    if (item.EDCSS =='number') {
                                        return (
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>
                                                </div>
                                                <div style="display:flex">
                                                    <select  style="width:60px;background:white;height:28px;margin-top:1px" value={this.v_row[`#OPER`+column.key]} on-change={(e)=>{this.inputChg(e,`#OPER`+column.key)}}>
                                                        <option value="=">=</option>
                                                        <option value=">">&gt;</option>
                                                        <option value="<">&lt;</option>
                                                        <option value="!=">!=</option>
                                                    </select>
                                                    <el-input disabled={item.EDCSS=='image'} v-model={this.v_row[column.key]} on-change={()=>this.inputQry()} style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini"></el-input>
                                                </div>
                                            </div>
                                        )
                                    }else{
                                        if (item.EDCSS=='checkbox'){
                                            return (
                                                <div >
                                                    <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                        <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>
                                                    </div>
                                                    <div style="display:flex">
                                                        <el-select size="mini" style="width:100%;background:white;height:28px;margin-top:1px" v-model={this.v_row[column.key]} on-change={()=>{this.inputQry()}}>
                                                            <el-option value="Y" label="是"></el-option>
                                                            <el-option value="N" label="否"></el-option>
                                                        </el-select>
                                                    </div>
                                                </div>
                                            )
                                        }else {
                                            return (
                                                <div >
                                                    <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                        <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>
                                                    </div>
                                                    <div style="display:flex">
                                                        <input disabled={item.EDCSS=='image'} v-model={this.v_row[column.key]} on-keyup={(event)=>{if (event.key=='Enter') this.inputQry()}} on-change={()=>this.inputQry()} style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini"></input>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    }
                                },
                                renderBodyCell: ({row}) => {
                                    const value = row[item.key]
                                    if (item.key === 'IDNO2') {
                                        return <el-link underline={false} on-click={() => this.repBtn(row)}><span style="color:#409eff;border-bottom:1px solid red;font-size:12px">{value}</span></el-link>
                                    }
                                    if (item.key === 'STFG') {
                                        return value === 'Y'
                                            ? <el-tag size="mini" type="success" effect="dark">{this.$LANG('1976', '已审核')}</el-tag>
                                            : <el-tag size="mini" type="info" effect="dark">{this.$LANG('2005', '未审核')}</el-tag>
                                    }
                                    if (item.key === 'IMGPATH') {
                                        return <el-image fit="scale-down" style="width:100%;height:24px" src={value} preview-src-list={[value]}><div slot="error"><i class="el-icon-picture-outline"></i></div></el-image>
                                    }
                                    if (item.EDCSS === 'checkbox') {
                                        return <el-checkbox disabled true-label="Y" false-label="N" v-model={row[item.key]}></el-checkbox>
                                    }
                                    return value
                                },
                            })
                        }
                }
                vm.vueCol.unshift({
                        field: 'index',
                        key: 'rownum',
                        title: '序号',
                        width: 55,
                        align: 'center',
                        fixed: 'left',
                        disableResizing: true,
                        renderHeaderCell: ({column}) => <div><div style="margin-top:3px">{column.title}</div><el-link on-click={this.rowShow} style="font-size:12px;color:#404eff;height:30px"><el-tooltip content={this.$LANG('0852', '清除条件')} effect="light"><i class="iconfont icon-shanchu1"></i></el-tooltip></el-link></div>,
                        renderBodyCell: ({rowIndex}) => rowIndex + 1,
                    })
                vm.vueCol.push({
                        field: 'oper0',
                        key: 'oper',
                        title: vm.$LANG('0330', '操作'),
                        width: 140,
                        align: 'center',
                        fixed: 'right',
                        disableResizing: true,
                        renderBodyCell: ({row, rowIndex}) => (
                            <div>
                                <i class="iconfont icon-chakan1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link on-click={() => this.editRec(row, 'Y', rowIndex)} underline={false}><span style="font-size:11px;margin-right:5px">{this.$LANG('0139', '查看')}</span></el-link>
                                {row.STFG === 'N' ? <span><i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i><el-link disabled={this.editBool} on-click={() => this.editRec(row, 'N', rowIndex)} underline={false}><span style="font-size:11px;margin-right:5px">{this.$LANG('1639', '编辑')}</span></el-link><i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i><el-link disabled={this.cancelBool} on-click={() => this.delRec(row, rowIndex)} underline={false}><span style="font-size:11px">{this.$LANG('0131', '删除')}</span></el-link></span> : null}
                            </div>
                        ),
                })
                vm.getSetList()
            })
        },
    }
}
</script>
<style scoped lang="less">
    .active { 
        color: #389;
        border-bottom:3px solid #cc0000;
        margin-right:2px;
    }
    .oneMenu{
        display:flex;
        flex-direction:column;
        line-height:25px;
        background:white;
        margin-top:3px;
        font-size:13px;
        font-weight: 600;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#cc0000;
        background:#f7f8f9;
        font-weight:700;
    }
    .item-width  {
        height:20px;
        width: 32%;
    }
    .item-one {
        width: 97%;
        height:105px;
    }
    .custom-button {
      background: rgb(107, 104, 104);
      font-weight:600;
      font-size:14px;
      color:#cc0000 !important;
      border-radius: 4px 4px 4px 4px;
    }
    .custom-button:hover {
     // background: rgb(107, 104, 104);//rgb(248, 230, 230) !important;
      font-weight:600;
      font-size:14px;
      color:#389 !important;
      border-radius: 4px 4px 4px 4px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
<style lang="less">
    /* 增大checkbox的方框大小 */
    .large-checkbox .el-checkbox__inner {
        width: 18px !important;  /* 设置方框的宽度 */
        height: 18px !important; /* 设置方框的高度 */
    }
    /* 调整对勾大小 */
    .large-checkbox .el-checkbox__inner::after {
        width: 6px !important;  /* 设置对勾的宽度 */
        height: 9px !important;  /* 设置对勾的高度 */
    }
    .el-range-separator {
        width: 20px !important;
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    //.el-dialog__headerbtn i { background:white;font-size: 20px;  }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
